// import { logout } from '../entry/session_actions'
import { RECEIVE_SERVER_ERRORS } from "./errorActions";
import { isEmpty } from "../../utilities";

const ErrorMiddleware = (store) => (next) => (action) => {
  const state = store.getState();
  if (action.type === RECEIVE_SERVER_ERRORS) {
    if (action.xhr.status === 401 && !isEmpty(state.session.currentUser)) {
      // return store.dispatch(logout())
    }
  }
  return next(action);
};

export default ErrorMiddleware;
